export class VerificationCallbackLogsPaged {
    total: number;
    verificationCallbackLogs: VerificationCallbackLog[];

    constructor(props: { [key in keyof VerificationCallbackLogsPaged]?: VerificationCallbackLogsPaged[key] }) {
        Object.assign(this,
            {
                verificationCallbackLogs: [],
                ...props
            });
    }
}

export class VerificationCallbackLog {
    id: number;
    url: string;
    responseCode: string;
    payload: string;
}